import mainConfig from './default'

export default {
  ...mainConfig,
  AUTHORIZATION_REQUIRED: false,
  KEY_REQUIRED: true,
}
